import { Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  JustifyContent,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import { EmptyWrapper } from 'modules/Drives/Components/Styles/style'
import CandidatesStatus from 'modules/Roles/ViewRole/CandidatesTable/CandidatesStatus'
import React from 'react'
import { toCamelCase } from '../../../../Data'
import CandidateFilter from '../CandidateFilter/index'
import {
  RowNumberCandidateAlignCenter,
  RowNumberCandidateAlignCenterItem,
  RowNumberCandidateData,
  RowNumberData,
} from '../CandidateTable/style'
function CandidateTable({
  setCandidateRating,
  candidateFilterData,
  individualDrawerQuestion,
  status,
  questionId,
  setCandidateFilterData,
  rowSelection,
  setCandidateStatus,
  candidateStatus,
  searchValue,
  pageNum,
  setSearchValue,
  setPageNum,
  handleSort,
  candidateRating,
  handleClick,
  loading,
  setTextNew,
  setClear,
  setSelectedRowKeys,
}) {
  const columns = [
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      width: '50%',
      align: 'left',
      render: (_, item) => (
        <FlexWrap
          gap="20px"
          style={{ cursor: 'pointer' }}
          onClick={() => handleClick(item?.student?.id, item?.isApplied)}
        >
          <AntdAvatar
            src={item?.student?.profileUrl}
            size={37}
            IconName={'s'}
          />
          <RowNumberCandidateData>
            {toCamelCase(item.student?.firstName) +
              ' ' +
              toCamelCase(item.student?.lastName)}
          </RowNumberCandidateData>
        </FlexWrap>
      ),
    },

    // {
    //   title: 'Rank',
    //   dataIndex: 'rating',
    //   sorter: true,
    //   width: '20%',
    //   align: 'center',
    //   render: rating => (
    //     <JustifyContent>
    //       <RowNumberCandidateAlignCenter>
    //         {}
    //         {Number(rating) > 0 ? (
    //           <FlexWrap gap="8px">
    //             <RowNumberData>{Number(rating)?.toFixed(2)}</RowNumberData>
    //             <AntdAvatar
    //               size={22}
    //               IconName={<GreenStarIcon />}
    //               background="none"
    //             />
    //           </FlexWrap>
    //         ) : (
    //           '0'
    //         )}
    //       </RowNumberCandidateAlignCenter>
    //     </JustifyContent>
    //   ),
    // },
    {
      title: 'Status',
      dataIndex: 'isApplied',
      align: 'center',
      sorter: true,
      width: '20%',
      render: isApplied => (
        <RowNumberCandidateAlignCenterItem>
          <CandidatesStatus status={isApplied} />
        </RowNumberCandidateAlignCenterItem>
      ),
    },
  ]

  const onPageChange = value => {
    setPageNum(value)
    setClear(true)
    setTextNew(false)
    setSelectedRowKeys([])
  }
  return (
    <div>
      <div style={{ marginTop: '30px', border: '1px solid #E6E7EA' }}>
        <CandidateFilter
          candidateFilterData={candidateFilterData}
          candidateRating={candidateRating}
          setCandidateRating={setCandidateRating}
          individualDrawerQuestion={individualDrawerQuestion}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          setCandidateStatus={setCandidateStatus}
          candidateStatus={candidateStatus}
          setCandidateFilterData={setCandidateFilterData}
        />
        <StyledTable
          rowKey={record => record?.student?.id}
          onChange={handleSort}
          columns={columns}
          pagination={false}
          dataSource={individualDrawerQuestion?.result}
          rowSelection={rowSelection}
          fontSize={true}
          fontWeight={true}
          scroll={{
            y: 600,
            x: 400,
          }}
          locale={{
            emptyText: (
              <EmptyWrapper center isSpin={loading}>
                {loading ? <Spin /> : 'No Candidates Found'}
              </EmptyWrapper>
            ),
          }}
        />
      </div>
      <Pagination
        onChange={onPageChange}
        totalPages={individualDrawerQuestion?.totalPage * 10}
        pageSize={10}
        current={pageNum || pageNum + 1}
      />
    </div>
  )
}

export default CandidateTable
